import { onBeforeUnmount, onMounted } from 'vue'
import { useRoute } from 'vue-router'

import { routeCatalogues } from '@/app/i18n'
import { identifyCrispUser } from '@/app/integrations/crisp'
import { loadAccount, loadWorkspaces, refreshSession } from '@/app/session'
import { useAuthStore } from '@/app/stores/auth'
import { useCountsStore } from '@/app/stores/counts'

/**
 * What a layout with the navbar loads (the vertical layout, and the AI layout — docs/ai-mode/wp/AI-1.md), as the legacy
 * navbar and nav did on mount: the Staff permission refresh, the workspaces, the account (language, date format) and
 * the badge polling, which stops when the layout unmounts or the session ends (NEW-14). Call it from the layout's setup.
 */
export function useSessionChrome(): void {
  const route = useRoute()
  const auth = useAuthStore()
  const counts = useCountsStore()

  onMounted(() => {
    if (!auth.session) return
    if (auth.userType === 'Staff') void refreshSession().catch(() => undefined)
    void loadWorkspaces().catch(() => undefined)
    void loadAccount(routeCatalogues(route.meta))
      .then(() => {
        if (auth.session) identifyCrispUser(auth.session.profile, auth.session.currentWorkspace)
      })
      .catch(() => undefined)
    counts.start()
  })

  onBeforeUnmount(() => counts.stop())
}
